import HttpService from './http.service'

export function getOptions() {
  return HttpService.get('get-options').then((result) => {
    const { data } = result
    return data
  })
}
